import * as React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Typography } from "@mui/material";
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image";
import { styled } from "@mui/system";
import MyLink from "./MyLink";

const determineImageRatio = (image: IGatsbyImageData | undefined) => {
  if (image !== undefined) {
    const ratio = image.height / image.width;
    const result = Math.floor(ratio * 3);
    return result;
  }
  return undefined;
};

const variants: { [key: string]: { [k1: number]: number } } = {
  text: {
    0: 8,
    1: 6,
    2: 4,
  },
  images: {
    0: 4,
    1: 6,
    2: 8,
  },
};

const ResponsiveArticleListing2Col = ({ post }): JSX.Element => {
  const image = getImage(post.frontmatter.thumbImage);

  const HideContainer = styled(Container)(({ theme }) => ({
    padding: 0,
    [theme.breakpoints.up("md")]: {
      width: "100%",
      display: "none",
    },
  }));

  const HideContainerSmall = styled(Container)(({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  }));

  if (image !== undefined) {
    const imageCols = determineImageRatio(image);
    if (imageCols && imageCols < 3) {
      return (
        <MyLink key={post.id} to={post.fields.path}>
          <Grid
            container
            key={post.id}
            sx={{
              borderBottom: "1px solid #4f4f4f",
              marginBottom: 2,
              paddingBottom: 1,
            }}
          >
            <Grid item md={variants.text[imageCols]} sx={{ paddingRight: 1 }}>
              <Typography variant="h5" component="h3" gutterBottom>
                {post.frontmatter.title}
              </Typography>
              <HideContainer>
                <GatsbyImage image={image} alt={post.frontmatter.title} />
              </HideContainer>
              <Typography variant="body1" component="p">
                {post.excerpt}
              </Typography>
            </Grid>
            <Grid item md={variants.images[imageCols]}>
              <HideContainerSmall>
                <GatsbyImage image={image} alt={post.frontmatter.title} />
              </HideContainerSmall>
            </Grid>
          </Grid>
        </MyLink>
      );
    } else {
      return (
        <MyLink key={post.id} to={post.fields.path}>
          <Grid
            container
            key={post.id}
            sx={{
              borderBottom: "1px solid #4f4f4f",
              marginBottom: 2,
              paddingBottom: 1,
            }}
          >
            <Grid item md={9} sx={{ paddingRight: 1 }}>
              <Typography variant="h5" component="h3" gutterBottom>
                {post.frontmatter.title}
              </Typography>
              <HideContainer>
                <GatsbyImage image={image} alt={post.frontmatter.title} />
              </HideContainer>
              <Typography variant="body1" component="p">
                {post.excerpt}
              </Typography>
            </Grid>
            <Grid item md={3}>
              <HideContainerSmall>
                <GatsbyImage image={image} alt={post.frontmatter.title} />
              </HideContainerSmall>
            </Grid>
          </Grid>
        </MyLink>
      );
    }
  } else {
    return (
      <MyLink key={post.id} to={post.fields.path}>
        <Grid
          container
          key={post.id}
          sx={{
            borderBottom: "1px solid #4f4f4f",
            marginBottom: 2,
            paddingBottom: 1,
          }}
        >
          <Grid item xs={12} sx={{ paddingRight: 1 }}>
            <Typography variant="h5" component="h3" gutterBottom>
              {post.frontmatter.title}
            </Typography>
            <Typography variant="body1" component="p">
              {post.excerpt}
            </Typography>
          </Grid>
        </Grid>
      </MyLink>
    );
  }
};

export default ResponsiveArticleListing2Col;
